export default __webpack_public_path__ + "static/media/IMG_2975.036652c9.JPG";